import { defaultPinIcon } from 'global/Constants/leafletIcons';
import { LatLngExpression } from 'leaflet';
import { FC, useEffect } from 'react';
import { FeatureGroup, Marker, Popup, useMap } from 'react-leaflet';

interface IProps {
  location: LatLngExpression;
  popupMarker?: React.ReactNode;
  icon?: any;
}

const ShowLocationMap: FC<IProps> = ({ location, icon, popupMarker }) => {
  //hooks
  const map = useMap();

  useEffect(() => {
    map && location && map.flyTo(location);
  }, [location, map]);

  return (
    <FeatureGroup>
      <Marker position={location} icon={icon || defaultPinIcon}>
        {popupMarker && <Popup className='text-start'>{popupMarker}</Popup>}
      </Marker>
    </FeatureGroup>
  );
};

export default ShowLocationMap;
